import { render, staticRenderFns } from "./newProductionDeclare.vue?vue&type=template&id=a2477b54&scoped=true&"
import script from "./newProductionDeclare.vue?vue&type=script&lang=js&"
export * from "./newProductionDeclare.vue?vue&type=script&lang=js&"
import style0 from "./newProductionDeclare.vue?vue&type=style&index=0&id=a2477b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2477b54",
  null
  
)

export default component.exports